import type { CustomElementOptions } from 'vue';
import type { Router, RouterMatcher } from 'vue-router';

type App = Parameters<NonNullable<CustomElementOptions['configureApp']>>[0];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const initPlugins = (app: App, router: Router, matcher: RouterMatcher) => {
  app.config.compilerOptions.isCustomElement = (tag) => tag.startsWith('partner-widget');

  // vue-yandex-maps здесь не подключаем: плагин тянул бы библиотеку карт в стартовый бандл,
  // хотя карта грузится лениво. Настройки (apikey) задаёт SightMap перед initYmaps().
};
